import { createRouteContext } from '@/providers';
import { CampaignOptimizationRoute } from '@/types/routes';

const {
    RouteProvider: CampaignOptimizationRouteProvider,
    useRouteContext: useCampaignOptimizationRoute,
} = createRouteContext<CampaignOptimizationRoute>();

export { CampaignOptimizationRouteProvider, useCampaignOptimizationRoute };
